import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=df39fb48&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df39fb48",
  null
  
)

component.options.__file = "Form.vue"
export default component.exports